import IconAddCircleBold from "@shared/components/icons/AddCircleBold"
import { cx } from "@shared/components/untitledui/util/cx"
import { Button } from "react-aria-components"

interface Props {
  label: string
  dataTest: string
  /**
   * Left off when this is a menu's trigger — the trigger it sits in supplies the press, and a
   * handler of our own would fight it.
   */
  onPress?: () => void
  className?: string
}

/**
 * What a day with nothing on it offers, across the full width of the card under the course bar:
 * "Add Lesson" for an instructional class, "Add Note" for one that isn't. Transparent, because it
 * paints on whatever the slot around it already painted.
 *
 * Sizes are the design's, divided by the 1.6375 its 24.563px course title makes against our 15px
 * one: 22.563px label, 23px disc, 5.89px gap, 20px of vertical padding.
 */
export default function AddToDayButton({ label, dataTest, onPress, className }: Props) {
  return (
    <Button
      onPress={onPress}
      data-test={dataTest}
      className={cx(
        "group flex w-full cursor-pointer items-center justify-center gap-1 rounded-b-md px-2.5 py-3 text-sm leading-none font-semibold text-[rgba(71,71,71,0.8)] outline-hidden transition-colors hover:text-[rgba(71,71,71,1)] focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-focus-ring",
        className,
      )}
    >
      <IconAddCircleBold className="size-3.5 shrink-0 text-black/50 transition-colors group-hover:text-black/70" />
      {label}
    </Button>
  )
}
